import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Login.css";
import { AuthContext } from "../../Portfolio/context/Auth";

import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const redirectPath = location.state?.path || "/dashboard";

  const [user, setUser] = useState({ name: "", email: "", password: "" });
  const state = useContext(AuthContext);
  const [isLogin, setIsLogin] = state.isLogin;
  const [err, setErr] = useState("");

  // onChange inputs
  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });

    setErr("");
  };
  console.log(isLogin);
  // login submit
  const loginSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_server}/user/login`,
        {
          email: user.email,
          password: user.password,
        }
      );

      setUser({ name: "", email: "", password: "" });

      localStorage.setItem("tokenStorage", res.data.token);
      setIsLogin(true);

      setErr(res.data.msg);

      navigate(redirectPath, { replace: true });
    } catch (error) {
      error.response.data.msg && setErr(error.response.data.msg);
    }
  };

  return (
    <div className="container">
      <div className="center">
        <form className="formLogin" onSubmit={loginSubmit}>
          <h1>Login</h1>
          <p>{err}</p>
          <div className="txt_field">
            <input
              type="email"
              name="email"
              value={user.email}
              onChange={onChangeInput}
              required
            />
            <span></span>
            <label>Email</label>
          </div>

          <div className="txt_field">
            <input
              type="password"
              name="password"
              value={user.password}
              onChange={onChangeInput}
              required
            />
            <span></span>
            <label>Password</label>
          </div>

          <div className="login-btn">
            <button type="submit">Login</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
